@value md-up, lg-up from '../../../../../../../_shared/breakpoints.module.css';

.tableHeaderTools {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.subTablesContainer {
  padding: 20px 50px;
}

.subTable {
  margin-bottom: 20px;
}

.subTableTitle {
  font-size: 16px !important;
}

@media screen and (md-up) {
  .tableHeaderTools {
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

@media screen and (lg-up) {
  .header {
    flex-direction: row;
  }

  .header > :global(.ant-space-item) {
    flex: 1;
  }

  .tableHeaderTools > :global(.ant-space-item) {
    margin-bottom: 0;
  }
}

.pagingDataTable {
  font-weight: 400;
}

.pagingDataTable :global(.ant-table-container) {
  overflow-x: scroll;
}

.dataCombo {
  width: 150px;
}
